import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`

    *{
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    body{
        /* padding-left: 50px; */
        position: relative;
        background: ${props => props.theme.background};
        /* font-size: 14px; */
        font-family: 'Poppins';
        color: ${props => props.theme.text};

        /* font-size: calc([minimum size] + ([maximum size] - [minimum size]) * ((100vw - [minimum viewport width]) / ([maximum viewport width] - [minimum viewport width]))); */
        /* font-size: calc(14px + (26 - 14) * ((100vw - 300px) / (1600 - 300))); */

        font-size: calc(15px + (18 - 15) * ((100vw - 300px) / (1600 - 300)));

        h1{
            font-size:195%;
        }

        min-height: 100vh;

    }

`;
